import TrackingElement from '../../../elements/tracking/TrackingElement';
import pushEcommerceTrackingEvent from '../../../elements/tracking/helpers/pushEcommerceTrackingEvent';
import CurrencyFormatter from '../../../../js/helper/currency-formatter';
import { defineElement } from '@webtides/element-js';
import ProductCardEvents from './ProductCardEvents';

class ProductCardTracking extends TrackingElement {
    connected() {
        super.connected();

        this.$trackingTarget.addEventListener(ProductCardEvents.PRODUCT_CLICK, ev => {
            const { link } = ev.detail;
            const position = Array.from(ev.target.parentElement.children).findIndex(child => child === ev.target) + 1;

            this.trackProductLinkClick(link, position);
        });
    }

    trackProductLinkClick(link, position) {
        // TODO: keine fertige variante hier verfügbar. Deshalb Link getrackt. (Produktkarte konzeptionell anders)
        pushEcommerceTrackingEvent('productClick', {
            currency: CurrencyFormatter.currency(),
            click: {
                actionField: {
                    list: this.findTrackingContext(),
                },
                products: [
                    {
                        link,
                        position,
                    },
                ],
            },
        });
    }
}

defineElement('product-card-tracking', ProductCardTracking);
